import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const InputContentStyled = styled('div')(({ theme }) => ({
  flex: 1,
  borderRadius: 12,
  borderColor: Colors.gray300,
  borderWidth: 1,
  borderStyle: 'solid',
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',

  '&:focus-within': {
    borderColor: Colors.blue500,
  },

  '&:after': {
    content: '""',
    display: 'block',
    paddingBottom: '100%',
  },

  '&.filled': {
    borderColor: Colors.gray500,
  },
  '&.error': {
    borderColor: Colors.red100,
    backgroundColor: Colors.red200,
  },

  input: {
    height: '100%',
    width: '100%',
    outline: 'none',
    textAlign: 'center',
    color: theme.palette.text.primary,

    ...theme.typography.bodyMedium,

    border: 'none',

    backgroundColor: 'transparent',
  },
}));
